import { MEAL_SUBTYPE_PREFIX } from 'context'
import { isEmpty } from 'lodash-es'

export const selectMealSubtypes = (typeFilter: string[]) => {
  if (isEmpty(typeFilter)) return []

  const mealSubtypes = typeFilter.filter(isMealSubtype)
  return mealSubtypes
}

const isMealSubtype = (subtype: string) => {
  return subtype.split('.')[0] === MEAL_SUBTYPE_PREFIX
}
